/**
 * Abre la constancia (PDF) en una pestaña nueva.
 * Usa fetch nativo en lugar de vue-resource: con responseType blob, vue-resource
 * puede disparar el catch antes de tiempo mientras aún llega el cuerpo binario.
 *
 * @param {Object} http Vue.$http (solo se usa http.options.root)
 */

function _bearerToken() {
  let apiKey = localStorage.getItem("apiKey_lms");
  if (!apiKey || apiKey === "undefined") {
    return "";
  }
  try {
    return JSON.parse(apiKey);
  } catch (e) {
    return apiKey;
  }
}

function _apiUrl(http, path) {
  const root =
    http && http.options && http.options.root
      ? String(http.options.root).replace(/\/+$/, "")
      : "";
  const rel = String(path).replace(/^\/+/, "");
  if (!root) {
    return rel;
  }
  return `${root}/${rel}`;
}

function _abrirPdfDesdeApi(http, pathRelativo) {
  const url = _apiUrl(http, pathRelativo);
  const token = _bearerToken();
  const headers = {
    Accept: "application/pdf, application/octet-stream, */*"
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  return fetch(url, {
    method: "GET",
    headers,
    credentials: "same-origin"
  })
    .then(res => {
      if (!res.ok) {
        return Promise.reject(new Error(`HTTP ${res.status}`));
      }
      return res.blob();
    })
    .then(blob => {
      if (!blob || blob.size === 0) {
        return Promise.reject(new Error("Respuesta vacía"));
      }
      const tipo = (blob.type || "").toLowerCase();
      if (blob.size < 800 && !tipo.includes("pdf")) {
        return blob.text().then(txt => {
          const msg = (txt && txt.slice(0, 200)) || "No es un PDF";
          return Promise.reject(new Error(msg));
        });
      }
      // Sin application/pdf el navegador muestra el binario como texto en la pestaña blob:
      const pdfBlob = tipo.includes("pdf")
        ? blob
        : new Blob([blob], { type: "application/pdf" });
      const objectUrl = window.URL.createObjectURL(pdfBlob);
      const w = window.open(objectUrl, "_blank");
      if (!w) {
        window.URL.revokeObjectURL(objectUrl);
        return Promise.reject(new Error("Ventana bloqueada por el navegador"));
      }
      window.setTimeout(() => window.URL.revokeObjectURL(objectUrl), 120000);
    });
}

export function abrirConstanciaCursoPdf(http, cveEmpleado, cveCurso) {
  const e = encodeURIComponent(cveEmpleado);
  const c = encodeURIComponent(cveCurso);
  const path = `plan_capacitacion/consultar_plan_capacitacion/constancia/${e}/${c}`;
  return _abrirPdfDesdeApi(http, path);
}

export function abrirConstanciaBloquePdf(http, cveEmpleado, idBloque) {
  const e = encodeURIComponent(cveEmpleado);
  const b = encodeURIComponent(idBloque);
  const path = `plan_capacitacion/consultar_plan_capacitacion/constancia-bloque/${e}/${b}`;
  return _abrirPdfDesdeApi(http, path);
}



// WEBPACK FOOTER //
// C:/Users/cesar/Documents/dev/LMSEDK/LMSDEKTernium-clone/D:/dev/LMSEDK/LMSDEKTernium-clone/src/utils/constanciaDownload.js